import React, { useEffect, useState } from "react";
import { fetchAllRack } from "../../../resources/RackResource";
import { fetchAllWarehouse } from "../../../resources/WarehouseResource";
import FabricCanvas from "../../../utils/FabricCanvas";
import { baseUrl } from "../../../constants/Constant";

function SettingLayout() {
  const [dataRack, setDataRack] = useState([]);
  const [dataWarehouse, setDataWarehouse] = useState([]);

  const [warehouseIdFilter, setWarehouseIdFilter] = useState("default");

  const fetchRack = () => {
    fetchAllRack()
      .then((res) => {
        setDataRack(res.data);
      })
      .catch((err) => {
        setDataRack([]);
      });
  };

  const fetchWarehouse = () => {
    fetchAllWarehouse()
      .then((res) => {
        setWarehouseIdFilter(res.data[0].id);
        setDataWarehouse(res.data);
      })
      .catch((err) => {
        setDataWarehouse([]);
      });
  };

  let filteredItems = dataRack.filter((item) => {
    // eslint-disable-next-line
    return item.warehouse_id == warehouseIdFilter;
  });

  let filteredItemsWarehouse = dataWarehouse.filter((item) => {
    // eslint-disable-next-line
    return item.id == warehouseIdFilter;
  });

  useEffect(() => {
    fetchRack();
    fetchWarehouse();
  }, []);

  const onChangeHandlerWarehouseFilter = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("id");
    setWarehouseIdFilter(option);
  };

  return (
    <div className="page-content-wrapper">
      <div className="page-content">
        <div className="card">
          <div className="card-body">
            <div className="card-title">
              <div className="row gy-3">
                <div className="col-md-10">
                  <h4 className="mb-0">Setting Layout Rack</h4>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-md-3">
                <label className="form-label">Warehouse :</label>
                <select
                  className="form-select mb-3"
                  aria-label="Default select example"
                  value={warehouseIdFilter}
                  onChange={(e) => onChangeHandlerWarehouseFilter(e)}
                >
                  <option value="default" disabled>
                    Select Warehouse
                  </option>
                  {dataWarehouse.map((data) => {
                    return (
                      <option id={data.id} key={data.id} value={data.id}>
                        {data.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <br />
            <div className="table-responsive">
              <div
                style={{
                  width: "100%",
                  height: "650px",
                  backgroundImage: `url('${baseUrl}/${
                    filteredItemsWarehouse.length === 0
                      ? ""
                      : filteredItemsWarehouse[0].image
                  }')`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <FabricCanvas initialBoxData={filteredItems} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingLayout;
